module.exports = __webpack_public_path__ + "static/media/lr.7f661fb0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/lr.svg
// module id = 877
// module chunks = 0